"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startWith = startWith;

var _ArrayObservable = require("../observable/ArrayObservable");

var _ScalarObservable = require("../observable/ScalarObservable");

var _EmptyObservable = require("../observable/EmptyObservable");

var _concat = require("../observable/concat");

var _isScheduler = require("../util/isScheduler");

/* tslint:enable:max-line-length */

/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
  for (var _len = arguments.length, array = new Array(_len), _key = 0; _key < _len; _key++) {
    array[_key] = arguments[_key];
  }

  return function (source) {
    var scheduler = array[array.length - 1];

    if ((0, _isScheduler.isScheduler)(scheduler)) {
      array.pop();
    } else {
      scheduler = null;
    }

    var len = array.length;

    if (len === 1) {
      return (0, _concat.concat)(new _ScalarObservable.ScalarObservable(array[0], scheduler), source);
    } else if (len > 1) {
      return (0, _concat.concat)(new _ArrayObservable.ArrayObservable(array, scheduler), source);
    } else {
      return (0, _concat.concat)(new _EmptyObservable.EmptyObservable(scheduler), source);
    }
  };
}